export default "__VITE_ASSET__CyAANo8W__"